import { OpsColor, OpsPunto } from './embriones.interface';

/**
 * Espejo de `EtiquetaPajuela` en el backend: `20260818-2.3-rojo`.
 *
 * Existe solo para previsualizar la identificación mientras se eligen las marcas;
 * la etiqueta que se muestra en las listas viene calculada del backend.
 */
export function etiquetaPajuela(
  fechaVit: string | null | undefined,
  punto: OpsPunto | null | undefined,
  color: OpsColor | null | undefined,
): string | null {
  if (!fechaVit || !punto || !color) {
    return null;
  }

  const fecha = fechaVit.slice(0, 10).replace(/-/g, '');

  return `${fecha}-${punto.codigo}-${slug(color.nombre)}`;
}

/**
 * Equivalente de `Str::slug` de Laravel para lo que llega acá: nombres de color.
 *
 * Un `toLowerCase()` pelado alcanzaba para Rojo/Verde/Negro, pero el catálogo es
 * editable: con "Azul Claro" el preview decía `azul claro` y el backend guardaba
 * `azul-claro`, o sea que la vista previa mentía apenas alguien agregara un color
 * de dos palabras o con acento.
 */
function slug(valor: string): string {
  return valor
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}
